export const server_base_endpoints = {
  job: {
    upsert_job: "/job/upsert-job",
    get_job: "/job/get-job",
  },
  grn: {
    upsert_gate_entry: "/grn/upsert-gate-entry",
    get_gate_entry: "/grn/get-gate-entry",
    upsert_grn: "/grn/upsert-grn",
    get_grn: "/grn/get-grn",
    upsert_material_outward: "/grn/material-outward",
    upsert_internal_store_transfer: "/grn/make-internal-store-transfer",
    get_internal_store_transfer: "/grn/get-internal-store-transfer",
  },
  purchase_invoice: {
    upsert_purchase_invoice: "/purchase_invoice/upsert-purchase-invoice",
    get_purchase_invoice: "/purchase_invoice/get-purchase-invoice",
  },
  purchase_order: {
    upsert_purchase_order: "/purchase_order/upsert-purchase-order",
    get_purchase_order: "/purchase_order/get-purchase-order",
  },
  service: {
    upsert_service_requesition: "/service/upsert-service-requesition",
    get_service_requesition: "/service/get-service-requesition",
    upsert_service_order: "/service/upsert-service-order",
    get_service_order: "/service/get-service-order",
    service_requesition: {
      post: "/service/upsert-service-requesition",
      get: "/service/get-service-requesition",
    },
    service_order: {
      post: "/service/upsert-service-order",
      get: "/service/get-service-order",
    },
    service_invoice: {
      post: "/service/upsert-service-invoice",
      get: "/service/get-service-invoice",
    },
  },
  ledger: {
    get_ledger: "/ledger/get-ledger",
  },
  approvals: {
    get_approval: "/approval/get-approval",
  },
  expense: {
    category_head: {
      post: "/expense/upsert-category-head",
      get: "/expense/get-category-head",
    },
  },
};
